import React, { Component } from 'react'
import { Modal, Tabs } from 'hljd'
import styles from './style.module.less'

const TabPane = Tabs.TabPane

export default class extends Component {
  render() {
    const { visible, onCancel } = this.props
    return (
      <Modal
        title="人气四大"
        footer={null}
        width={460}
        visible={visible}
        onCancel={onCancel}
        bodyStyle={{
          padding: '10px 20px 24px'
        }}
      >
        <div className={styles.header}>
          坚持使用婚礼纪档期工具，结合您的使用习惯和档期记录情况，将会为您在用户端点亮「人气四大」标签，并有机会入选网红四大和人气频道，尊享更多曝光机会。
        </div>
        <div className={styles.main}>
          <Tabs
            tabPosition="left"
            defaultActiveKey="0"
            tabBarStyle={{ width: 123 }}
          >
            <TabPane tab="个人主页" key="0">
              <img
                src="//qnm.hunliji.com/Frsu0VwhyU-jW0GLK1uAReuzq1eH"
                className={styles.img}
              />
            </TabPane>
            <TabPane tab="商家列表" key="1">
              <img
                src="//qnm.hunliji.com/FrldTfTjafBKFv7ljDBLU2vmNbsz"
                className={styles.img}
              />
            </TabPane>
            <TabPane tab="入选人气频道" key="2">
              <img
                src="//qnm.hunliji.com/Fl9chSuOaHjuIIxkB4VGghSPq2W1"
                className={styles.img}
              />
            </TabPane>
          </Tabs>
        </div>
      </Modal>
    )
  }
}
